/**
 * Copies `text`, resolving false when the write fails or has not settled in time:
 * in a background tab `writeText` can stay pending for good.
 */
export async function copyText(text: string, timeoutMs = 1500): Promise<boolean> {
  let timer: ReturnType<typeof setTimeout> | undefined;
  const timeout = new Promise<boolean>((resolve) => {
    timer = setTimeout(() => resolve(false), timeoutMs);
  });
  const write = Promise.resolve()
    .then(() => navigator.clipboard.writeText(text))
    .then(
      () => true,
      () => false
    );
  try {
    return await Promise.race([write, timeout]);
  } finally {
    clearTimeout(timer);
  }
}
